import React from 'react';

const Input = ({
    label,
    name,
    type = 'text',
    value,
    onChange,
    placeholder = '',
    error = '',
    icon = null,
    required = false,
    disabled = false,
    autoComplete,
    className = '',
    style = {},
    ...props
}) => {
    return (
        <div style={{ marginBottom: '16px', width: '100%' }}>
            {label && (
                <label
                    htmlFor={name}
                    style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#d1d5db',
                        marginBottom: '6px',
                    }}
                >
                    {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
                </label>
            )}
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                {icon && (
                    <span
                        style={{
                            position: 'absolute',
                            left: '12px',
                            color: '#9ca3af',
                            display: 'flex',
                            alignItems: 'center',
                            pointerEvents: 'none',
                        }}
                    >
                        {icon}
                    </span>
                )}
                <input
                    id={name}
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    disabled={disabled}
                    autoComplete={autoComplete}
                    style={{
                        width: '100%',
                        padding: icon ? '10px 12px 10px 40px' : '10px 14px',
                        backgroundColor: '#111827',
                        color: '#f9fafb',
                        border: error ? '1px solid #ef4444' : '1px solid #374151',
                        borderRadius: '8px',
                        fontSize: '14px',
                        outline: 'none',
                        transition: 'border-color 0.2s ease-in-out',
                        boxSizing: 'border-box',
                        ...style,
                    }}
                    className={`input-common ${className}`}
                    {...props}
                />
            </div>
            {error && (
                <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', margin: '4px 0 0 0' }}>
                    {error}
                </p>
            )}
        </div>
    );
};

export default Input;
